
export const getLocationData = (state) => {
  const {
    location,
  } = state;

  return location;
}
